"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3685],{

/***/ 13685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Post = function Post(_ref) {
  var categories = _ref.categories,
      title = _ref.title,
      excerpt = _ref.excerpt,
      image = _ref.image,
      day = _ref.day,
      month = _ref.month,
      href = _ref.href;
  var cleanCategories = categories.filter(function (category) {
    return category !== 'Noleggio a Lungo Termine';
  });
  var categoriesList = cleanCategories.join(' | ');
  var descriptionLength = Math.round(288 - (categoriesList.length + title.length * 1.5));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
    title: title,
    href: href,
    target: "_blank",
    rel: "noreferrer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      w: "full",
      bg: "baseWhite",
      rounded: "md",
      p: 6,
      borderRadius: 10,
      overflow: "hidden",
      borderColor: "#d9dde1",
      borderWidth: "1px",
      boxShadow: "0 2px 8px 0px rgba(65, 164, 118, 0.12)",
      h: "30rem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        h: "12.5rem",
        mt: -6,
        mx: -6,
        pos: "relative",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          h: "12.5rem",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: image,
            alt: title,
            layout: "fill",
            loading: "lazy",
            decoding: "async"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .DateBox */ .L9, {
            day: day,
            month: month
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq, {
        marginTop: "m",
        h: "calc(100% - 11.3rem);",
        overflow: "hidden",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
          color: "green.500",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1rem",
          lineHeight: "20.8px",
          letterSpacing: "0.2px",
          textAlign: "left",
          children: categoriesList
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
          color: "baseNeutral.700",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.75rem",
          lineHeight: "15.6px",
          letterSpacing: "0.4px",
          textAlign: "left",
          display: "inherit"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
          as: "h6",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.375rem",
          lineHeight: "28.6px",
          letterSpacing: "0.57px",
          textAlign: "left",
          marginTop: "m",
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "1rem",
          lineHeight: "20.8px",
          letterSpacing: "0.2px",
          textAlign: "left",
          marginTop: ".562rem",
          children: "".concat(excerpt.substring(0, descriptionLength), "...")
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Post);

/***/ })

}]);